// extracted by mini-css-extract-plugin
module.exports = {"MasterArtikalCMS":"MasterArtikalCMS_MasterArtikalCMS__3aBRx"};